var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 59C45.7924 59 59 45.7924 59 29.5C59 13.2076 45.7924 0 29.5 0C13.2076 0 0 13.2076 0 29.5C0 45.7924 13.2076 59 29.5 59ZM16.8574 16.8561L40.4574 16.8561C41.7987 16.8561 43.085 17.3889 44.0334 18.3373C44.9818 19.2857 45.5146 20.572 45.5146 21.9133L45.5146 38.7704C45.5146 40.1117 44.9818 41.398 44.0334 42.3464C43.085 43.2948 41.7987 43.8276 40.4574 43.8276L16.8574 43.8276C15.5162 43.8276 14.2299 43.2948 13.2815 42.3464C12.3331 41.398 11.8003 40.1117 11.8003 38.7704L11.8003 21.9133C11.8003 20.572 12.3331 19.2857 13.2815 18.3373C14.2299 17.3889 15.5162 16.8561 16.8574 16.8561ZM28.6574 28.2347L39.328 20.2276L17.9869 20.2276L28.6574 28.2347ZM16.8574 40.4561L40.4574 40.4561C40.9045 40.4561 41.3333 40.2785 41.6494 39.9624C41.9655 39.6463 42.1431 39.2175 42.1431 38.7704V22.3347L29.6689 31.6904C29.3771 31.9093 29.0222 32.0276 28.6574 32.0276C28.2927 32.0276 27.9378 31.9093 27.646 31.6904L15.1717 22.3347L15.1717 38.7704C15.1717 39.2175 15.3493 39.6463 15.6654 39.9624C15.9816 40.2785 16.4103 40.4561 16.8574 40.4561Z",
    fill: "#9C7DF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5ff549328e38973dcc6a30b70a7d97ea.svg";
export { ForwardRef as ReactComponent };